module.exports = __webpack_public_path__ + "img/daichao1.70d540b7.png";